export default __webpack_public_path__ + "static/media/3.184f5572.svg";